import type { PublicApiKey } from '#packages/apilib';
import type { createSiteApi } from './siteWrapper';

export const SiteApiKey: PublicApiKey<typeof createSiteApi> = {
  name: 'SiteApi',
  public: true,
};
